import styled from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

export const Container = styled.div`
  background-color: ${themeGet('colors.background.screenAlt')};
  width: 100%;
`

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1500px;
  gap: ${themeGet('space.6')}px;

  @media screen and (min-width: ${themeGet('breakpoints.2')}) {
    gap: ${themeGet('space.11')}px;
  }

  ${padding}
`
